export const windInputCursor = e => {
  const range = document.createRange()
  const sel = window.getSelection()
  range.setStart(e.currentTarget, e.currentTarget.childNodes.length)
  range.collapse(true)
  sel.removeAllRanges()
  sel.addRange(range)
}
